/**
 * 챗봇 상태 관리 (Zustand)
 *
 * 관리하는 상태:
 * - 위젯 열림/닫힘
 * - 메시지 목록
 * - 타이핑 인디케이터
 * - 세션 ID
 *
 * 인증 정보는 별도 authStore에서 관리
 */

import { create } from 'zustand';
import type { ChatMessage, NewChatMessage } from '@/types/qa';
import { generateId } from '@/lib/utils';

interface ChatState {
  // 상태
  isOpen: boolean;
  messages: ChatMessage[];
  isTyping: boolean;
  sessionId: string;

  // 액션
  open: () => void;
  close: () => void;
  toggle: () => void;
  addMessage: (message: NewChatMessage) => void;
  removeMessage: (id: string) => void;
  setTyping: (typing: boolean) => void;
  reset: () => void;
}

const initialMessages: ChatMessage[] = [];

export const useChatStore = create<ChatState>((set) => ({
  isOpen: false,
  messages: initialMessages,
  isTyping: false,
  sessionId: generateId('sess'),

  open: () => {
    set({ isOpen: true });
  },

  close: () => {
    set({ isOpen: false });
  },

  toggle: () => {
    set((state) => ({ isOpen: !state.isOpen }));
  },

  addMessage: (message) => {
    set((state) => ({
      messages: [
        ...state.messages,
        {
          ...message,
          id: generateId('msg'),
          timestamp: new Date().toISOString(),
        },
      ],
    }));
  },

  removeMessage: (id) => {
    set((state) => ({
      messages: state.messages.filter((m) => m.id !== id),
    }));
  },

  setTyping: (typing) => {
    set({ isTyping: typing });
  },

  reset: () => {
    set({
      messages: initialMessages,
      isTyping: false,
      sessionId: generateId('sess'),
    });
  },
}));
